<template lang="html">
  <div class="emcPublicity">
    <div class="banner">
      <img :src="`${pagebase}/static/img/emc/banner.jpg`" alt="">
    </div>
    <div class="content">
      <!-- √ 你是否常常遇到这样的工作难题？ -->
      <div class="work">
        <img class="title" :src="`${pagebase}/static/img/emc/title_1.png`" alt="">
        <ul class="work_list">
          <li>
            <img class="work_icon" :src="`${pagebase}/static/img/emc/work_1.png`" alt="">
            <div class="work_con">
              <p class="work_list_child_title">通过率低？<span>(EMC测试通过率低)</span></p>
              <p class="work_list_child_con">根据权威实验室报告，电子产品平均首次EMC测试通过率只有50%。</p>
            </div>
          </li>
          <li>
            <img class="work_icon" :src="`${pagebase}/static/img/emc/work_2.png`" alt="">
            <div class="work_con">
              <p class="work_list_child_title">成本高？<span>(EMC性能与成本冲突)</span></p>
              <p class="work_list_child_con">产品要求更低的开发成本和测试成本，但常常因为EMC问题改板而增加额外的开发和测试成本。</p>
            </div>
          </li>
          <li>
            <img class="work_icon" :src="`${pagebase}/static/img/emc/work_3.png`" alt="">
            <div class="work_con">
              <p class="work_list_child_title">上市慢？<span>(因EMC问题导致产品上市慢)</span></p>
              <p class="work_list_child_con">产品需要更快的投入市场，但常常因为EMC问题而影响产品上市时间。</p>
            </div>
          </li>
          <li>
            <img class="work_icon" :src="`${pagebase}/static/img/emc/work_4.png`" alt="">
            <div class="work_cons">
              <p class="work_list_child_title">信号质量差？<span>(EMC问题影响信号质量)</span></p>
              <p class="work_list_child_con">产品需要更好的信号质量，但常常因为内部干扰问题而影响信号完整性。</p>
            </div>
          </li>
        </ul>
        <div class="crowd">
          <p class="crowd_title">这些人群一定要掌握EMC正向设计、定位整改、EMC仿真</p>
          <div class="crowd_con">
            <div class="">硬件工程师</div>
            <p></p>
            <div class="">电源工程师</div>
            <p></p>
            <div class="">EMC工程师</div>
            <p></p>
            <div class="">仿真工程师</div>
          </div>
        </div>
      </div>

      <!-- √ 课程特色 -->
      <div class="feature">
        <img class="title" :src="`${pagebase}/static/img/emc/title_2.png`" alt="">
        <div class="global">
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_1.png`" alt="">
                <p>专家授课</p>
              </div>
              <p class="promote_con">
                原华为EMC首席专家领衔，多位业界一流企业EMC专家授课；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_2.png`" alt="">
                <p>高质量视频课件</p>
              </div>
              <p class="promote_con">
                专业制作团队独创的动画演示效果，业界独有，直观易学；有仿真数据支撑的大量EMC量化设计规则；大量EMC经典案例分享；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_3.png`" alt="">
                <p>体系化的EMC课程内容</p>
              </div>
              <p class="promote_con">
                课程内容覆盖EMC基本概念和理论、EMC测试和认证、EMC设计、EMC整改、EMC仿真、经典案例和实战项目，
                可极大的满足EMC知识学习和技能提升需求；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_4.png`" alt="">
                <p>全流程实战</p>
              </div>
              <p class="promote_con">
                结合IPD流程，围绕实际产品，从EMC需求分析、系统EMC设计、详细EMC设计到EMC测试验证全流程的EMC正向设计讲解；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_5.png`" alt="">
                <p>专业的EMC仿真课程</p>
              </div>
              <p class="promote_con">
                理论讲解、实际操作和工程设计实例相结合，帮助没有CST软件使用基础的初学者快速入门，并且通过RE、CE、ESD仿真分析的实操演练，
                能够真正把EMC仿真应用到实际工作中去；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_6.png`" alt="">
                <p>“自学+带学”教学方式</p>
              </div>
              <p class="promote_con">
                学员自学课程后，专家直播带学帮助学员理解和掌握EMC知识要点，并为学员解答学习和工作中的疑问；
              </p>
            </div>
          </div>
          <div class="promote_content">
            <div class="promote_mod">
              <div class="promote_title">
                <img :src="`${pagebase}/static/img/emc/number_7.png`" alt="">
                <p>强大的教学平台</p>
              </div>
              <p class="promote_con">
                电巢自开发的巢粉引擎将学员的知识学习、实战和测验管理起来，每个学员都有学习档案，详细记录学习进度和测试结果。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- √ 参加EMC能力提升特训营，你将获得 -->
      <div class="reap">
        <img class="title" :src="`${pagebase}/static/img/emc/title_3.png`" alt="">
        <div class="">
          <ul class="reap_list">
            <li>
              <div class="reap_icon_1" style="background-color:#3353D8;">
                <img class="" :src="`${pagebase}/static/img/emc/reap_1.png`" alt="">
              </div>
              <div class="reap_con_1">
                <p class="reap_list_child_title">EMC理论水平提升</p>
                <p class="reap_list_child_con">系统、准确理解和掌握EMC基本概念、基本理论</p>
              </div>
            </li>
            <li>
              <div class="reap_icon_1" style="background-color:#6A87FF;">
                <img class="" :src="`${pagebase}/static/img/emc/reap_2.png`" alt="">
              </div>
              <div class="reap_con_1" style="background-color:#DDE8FC">
                <p class="reap_list_child_title">EMC设计能力提升</p>
                <p class="reap_list_child_con">显著提升EMC正向设计技能</p>
              </div>
            </li>
            <li>
              <div class="reap_icon_1" style="background-color:#3353D8;">
                <img class="" :src="`${pagebase}/static/img/emc/reap_3.png`" alt="">
              </div>
              <div class="reap_con_1">
                <p class="reap_list_child_title">EMC整改能力提升</p>
                <p class="reap_list_child_con">EMC问题快速、高效、准确定位整改的能力提升</p>
              </div>
            </li>
            <li>
              <div class="reap_icon_2" style="background-color:#6A87FF;">
                <img class="" :src="`${pagebase}/static/img/emc/reap_4.png`" alt="">
              </div>
              <div class="reap_con_2" style="background-color:#DDE8FC">
                <p class="reap_list_child_title">EMC仿真能力提升</p>
                <p class="reap_list_child_con">CST仿真软件快速入门，并学会和掌握CST软件在几个主要的EMC项目的仿真应用</p>
              </div>
            </li>
            <li>
              <div class="reap_icon_2" style="background-color:#3353D8;">
                <img class="" :src="`${pagebase}/static/img/emc/reap_5.png`" alt="">
              </div>
              <div class="reap_con_2">
                <p class="reap_list_child_title">正确开发习惯培养</p>
                <p class="reap_list_child_con">通过按IPD流程的EMC设计实战强化训练，养成正确的产品开发习惯</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 原华为EMC首席专家团 实战经验倾囊相授，为企业快速培养EMC工程师 -->
      <div class="teacher">
        <img class="title" :src="`${pagebase}/static/img/emc/title_6.png`" alt="" style="height: 4.8rem">
        <div class="">
          <div class="tab_css" id="tab1_content" style="display: block">
            <div class="teacher_con">
              <img class="teacher_head" :src="`${pagebase}/static/img/emc/teacher_1.png`" alt="">
              <div class="teacher_txt">
                <p class="teacher_synopsis">
                  原华为EMC首席专家，具有20余年产品研发经验。在EMC测试、EMC设计与整改、高频EMI技术研究和EMC仿真技术上有着丰富的经验。曾主导华为网络产品高频EMI技术研究，支撑下一代网络产品从5G-56G速率演进和市场准入。
                </p>
              </div>
            </div>
            <div class="teacher_honor">
              <p class="teacher_honor_name">余平放老师</p>
              <p class="teacher_honor_child">EDA365电磁兼容、安规论坛特邀版主、原华为EMC首席专家</p>
            </div>
            <img class="down_1" :src="`${pagebase}/static/img/emc/down.png`" alt="">
          </div>
          <div class="tab_css" id="tab2_content">
            <div class="teacher_con">
              <img class="teacher_head" :src="`${pagebase}/static/img/emc/teacher_2.png`" alt="">
              <div class="teacher_txt">
                <p class="teacher_synopsis">
                  在EMC领域有15+工作经验，3项专利第一发明人，负责华为30+平台产品EMC设计认证端到端交付，其中20+全新平台EMC系统设计，4款为4大产品线下一代主力平台。规划建设华为EMC领域规范/指导书/checklist/自动化工具/器件路标等质量保障体系。
                </p>
              </div>
            </div>
            <div class="teacher_honor">
              <p class="teacher_honor_name">叶玲老师</p>
              <p class="teacher_honor_child">EDA365电磁兼容、安规论坛特邀版主、原华为EMC设计专家</p>
            </div>
            <img class="down_2" :src="`${pagebase}/static/img/emc/down.png`" alt="">
          </div>
          <div class="tab_css" id="tab3_content">
            <div class="teacher_con">
              <img class="teacher_head" :src="`${pagebase}/static/img/emc/teacher_3.png`" alt="">
              <div class="teacher_txt">
                <p class="teacher_synopsis">
                  15年EMC行业产品研发经验，曾工作于华为赛门铁克、华为及多家上市公司，参与设计过intel、IBM、EMC2、NETAPP、华为等多家企业的存储阵列、服务器；此外还涉猎投影阵列与电子幕墙、摄像头录像机等多种跨行业产品。
                </p>
              </div>
            </div>
            <div class="teacher_honor">
              <p class="teacher_honor_name">常旭甦老师</p>
              <p class="teacher_honor_child">EDA365论坛特邀版主、原华为EMC设计专家</p>
            </div>
            <img class="down_3" :src="`${pagebase}/static/img/emc/down.png`" alt="">
          </div>
          <div class="tab_css" id="tab4_content">
            <div class="teacher_con">
              <img class="teacher_head" :src="`${pagebase}/static/img/emc/teacher_4.png`" alt="">
              <div class="teacher_txt">
                <p class="teacher_synopsis">
                  曾就职于华为、三星等世界500强知名企业；在无线通信基站、通信电源、汽车电子、军工等产品的EMC、防雷及安全设计、测试、整改、以及防雷接地工程方案的设计和实施等具有丰富的经验。
                </p>
              </div>
            </div>
            <div class="teacher_honor">
              <p class="teacher_honor_name">瞿祥虎老师</p>
              <p class="teacher_honor_child">EDA365论坛特邀版主、原华为EMC设计专家</p>
            </div>
            <img class="down_4" :src="`${pagebase}/static/img/emc/down.png`" alt="">
          </div>
          <div class="tab_bar" :class="{tabBtn: xHeader}">
            <ul>
              <li id="tab1" @click="myclick(1, 'all')" v-bind:class="{'decorationLine':showAll}">
                <!-- <div class="tab_line"></div> -->
                <img class="teacher_icon" v-bind:class="{'opacity':showAll}" :src="`${pagebase}/static/img/emc/teacher_1.jpg`" alt="">
                <p class="teacherName" v-bind:class="{'color': showAll}">余平放老师</p>
              </li>
              <li id="tab2" @click="myclick(2, 'await')" v-bind:class="{'decorationLine':showAwait}">
                <!-- <div class="tab_line"></div> -->
                <img class="teacher_icon" v-bind:class="{'opacity':showAwait}" :src="`${pagebase}/static/img/emc/teacher_2.jpg`" alt="">
                <p class="teacherName" v-bind:class="{'color': showAwait}">叶玲老师</p>
              </li>
              <li id="tab3" @click="myclick(3, 'accomplish')" v-bind:class="{'decorationLine':showAccomplish}">
                <!-- <div class="tab_line"></div> -->
                <img class="teacher_icon" v-bind:class="{'opacity':showAccomplish}" :src="`${pagebase}/static/img/emc/teacher_3.jpg`" alt="">
                <p class="teacherName" v-bind:class="{'color': showAccomplish}">常旭甦老师</p>
              </li>
              <li id="tab4" @click="myclick(4, 'cancel')" v-bind:class="{'decorationLine':showCancel}">
                <!-- <div class="tab_line"></div> -->
                <img class="teacher_icon" v-bind:class="{'opacity':showCancel}" :src="`${pagebase}/static/img/emc/teacher_4.jpg`" alt="">
                <p class="teacherName" v-bind:class="{'color': showCancel}">瞿祥虎老师</p>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <!-- 特训安排 -->
      <div class="arrange">
        <img class="title" :src="`${pagebase}/static/img/emc/title_5.png`" alt="">
        <div class="arrange_con">
          <img class="course_structure" :src="`${pagebase}/static/img/emc/course_structure.png`" alt="">
          <img class="catalogue" :src="`${pagebase}/static/img/emc/catalogue.png`" alt="">
          <p class="arrangeTag">《通用产品EMC正向设计》</p>
          <div class="arrange_list">
            <ul>
              <li>
                <div class="arrange_list_title">
                  《EMC基础》
                </div>
                <div class="arrange_list_con">
                  <div class="arrange_list_child">
                    <p class="course">
                      EMC的历史背景
                    </p>
                    <div class="child_course" style="height: 5.2rem;">
                      EMC的历史背景
                    </div>
                  </div>
                </div>
                <div class="arrange_list_con">
                  <div class="arrange_list_child">
                    <p class="course">
                      EMC基本术语
                    </p>
                    <div class="child_course">
                      电磁兼容性，准峰值和平均值，分贝换算，周期信号频谱，随机信号频谱，共模电流和差模电流等
                    </div>
                  </div>
                </div>
                <div class="arrange_list_con">
                  <div class="arrange_list_child">
                    <p class="course">
                      EMC基本理论
                    </p>
                    <div class="child_course">
                      电磁干扰三要素，电偶极子和磁偶极子，差模辐射和共模辐射，展频，回路电感、部分电感和净余部分电感等
                    </div>
                  </div>
                </div>
                <div class="arrange_list_con">
                  <div class="arrange_list_child">
                    <p class="course">
                      EMC法规、标准和认证
                    </p>
                    <div class="child_course">
                      <p><span></span>EMC认证和标准的基础知识</p>
                      <p><span></span>欧盟、北美、中国的EMC法规、标准和认证</p>
                      <p><span></span>重要行业的EMC标准</p>
                    </div>
                  </div>
                </div>
                <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                  <div class="arrange_list_child">
                    <p class="course">
                      EMC测试
                    </p>
                    <div class="child_course">
                      <p><span></span>EMC测试基础知识</p>
                      <p><span></span>信息技术设备类EMC测试</p>
                      <p><span></span>汽车零部件类EMC测试</p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="arrange_list_title">
                  《EMC设计》
                </div>
                <div class="arrange_list_con">
                  <div class="arrange_list_con">
                    <div class="arrange_list_child">
                      <p class="course">
                        EMC正向设计及流程
                      </p>
                      <div class="child_course">
                        <p><span></span>EMC正向设计</p>
                        <p><span></span>EMC设计流程</p>
                      </div>
                    </div>
                  </div>
                  <div class="arrange_list_con">
                    <div class="arrange_list_child">
                      <p class="course">
                        常用EMC器件
                      </p>
                      <div class="child_course">
                        <p><span></span>电容、电感、共模电感、铁氧体器件、<br>X2Y器件、吸波材料、展频芯片</p>
                        <p><span></span>EMC器件相关案例分析（4个）</p>
                      </div>
                    </div>
                  </div>
                  <div class="arrange_list_con">
                    <div class="arrange_list_child">
                      <p class="course">
                        EMC基本术语
                      </p>
                      <div class="child_course">
                        <p><span></span>接地相关的概念（安全地、机壳地、信号<br>地、直流电源回流地、功率地、接口地）</p>
                        <p><span></span>信号回流参考面噪声电压的来源</p>
                        <p><span></span>设备接地设计（局部接地设计、总体接地设计）</p>
                        <p><span></span>接地相关的EMC案例分析（2个）</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="show_all" @click="allCourse">
              点击查看全部课程安排
              <img :src="`${pagebase}/static/img/emc/all.png`" alt="">
            </div>
          </div>
        </div>
        <div class="tv">
          <p class="tv_title">课程试看</p>
          <br>
          <div class="videoCon">
            <p>1、 信号换参考对EMI影响分析片段</p>
            <video width="100%" height="100%" controls playsinline="true" :poster="`${pagebase}/static/img/emc/classNo1.jpg`">
              <source src="http://1500011843.vod2.myqcloud.com/6caa3839vodcq1500011843/da6332c4387702301720362840/yUu5kzKPNjYA.mp4" type="video/mp4">
            </video>
          </div>
          <div class="videoCon">
            <p>2、接地案例定位分析片段</p>
            <video width="100%" height="100%" controls playsinline="true" :poster="`${pagebase}/static/img/emc/classNo2.jpg`">
              <source src="http://1500011843.vod2.myqcloud.com/6caa3839vodcq1500011843/dfb7cd39387702301683767646/NS9pANuwCIAA.mp4" type="video/mp4">
            </video>
          </div>
          <div class="videoCon">
            <p>3、浪涌防护设计的必要性片段</p>
            <video width="100%" height="100%" controls playsinline="true" :poster="`${pagebase}/static/img/emc/classNo3.jpg`">
              <source src="http://1500011843.vod2.myqcloud.com/6caa3839vodcq1500011843/e47295fb387702301683974738/MIp3zfQ9NSEA.mp4" type="video/mp4">
            </video>
          </div>
        </div>
      </div>
      <div class="arrange_alert" v-bind:class="{'show': show}" @click="closeAlert">
        <div class="arrange_alert_list">

          <ul class="arrange_alert_txt">
            <li>
              <p class="arrangeTag">《通用产品EMC正向设计》</p>
            </li>
            <li>
              <div class="arrange_list_title">
                《EMC基础》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC的历史背景
                  </p>
                  <div class="child_course" style="height: 5.2rem;">
                    EMC的历史背景
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC基本术语
                  </p>
                  <div class="child_course">
                    电磁兼容性，准峰值和平均值，分贝换算，周期信号频谱，随机信号频谱，共模电流和差模电流等
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC基本理论
                  </p>
                  <div class="child_course">
                    电磁干扰三要素，电偶极子和磁偶极子，差模辐射和共模辐射，展频，回路电感、部分电感和净余部分电感等
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC法规、标准和认证
                  </p>
                  <div class="child_course">
                    <p><span></span>EMC认证和标准的基础知识</p>
                    <p><span></span>欧盟、北美、中国的EMC法规、标准和认证</p>
                    <p><span></span>重要行业的EMC标准</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC测试
                  </p>
                  <div class="child_course">
                    <p><span></span>EMC测试基础知识</p>
                    <p><span></span>信息技术设备类EMC测试</p>
                    <p><span></span>汽车零部件类EMC测试</p>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="arrange_list_title">
                《EMC设计》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    EMC正向设计及流程
                  </p>
                  <div class="child_course">
                    <p><span></span>EMC正向设计</p>
                    <p><span></span>EMC设计流程</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    常用EMC器件
                  </p>
                  <div class="child_course">
                    <p><span></span>电容、电感、共模电感、铁氧体器件、<br>X2Y器件、吸波材料、展频芯片</p>
                    <p><span></span>EMC器件相关案例分析（4个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    接地设计
                  </p>
                  <div class="child_course">
                    <p><span></span>接地相关的概念（安全地、机壳地、信号<br>地、直流电源回流地、功率地、接口地）</p>
                    <p><span></span>信号回流参考面噪声电压的来源</p>
                    <p><span></span>设备接地设计（局部接地设计、总体接地设计）</p>
                    <p><span></span>接地相关的EMC案例分析（2个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    滤波设计
                  </p>
                  <div class="child_course">
                    <p><span></span>电源端口滤波设计；</p>
                    <p><span></span>信号端口滤波设计；</p>
                    <p><span></span>板内关键电路滤波设计；</p>
                    <p><span></span>滤波相关案例分析（2个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    电源/地平面去耦设计
                  </p>
                  <div class="child_course">
                    <p><span></span>电源/地平面去耦的目的及其噪声来源</p>
                    <p><span></span>去耦电容去耦效果分析及设计规则</p>
                    <p><span></span>电源/地平面去耦相关案例分析（2个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    PCB布局、层叠和布线EMC设计
                  </p>
                  <div class="child_course">
                    <p><span></span>PCB布局EMC设计</p>
                    <p><span></span>PCB层叠EMC设计</p>
                    <p><span></span>关键信号跨分割EMI分析及设计规则</p>
                    <p><span></span>关键信号换参考EMI分析及设计规则</p>
                    <p><span></span>关键信号PCB边缘走线和包地EMI分析及设计规则</p>
                    <p><span></span>3W原则和20H原则的分析和应用</p>
                    <p><span></span>差分线EMI分析和设计规则</p>
                    <p><span></span>PCB布局和布线相关的EMC案例分析（3个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    屏蔽设计
                  </p>
                  <div class="child_course">
                    <p><span></span>电磁屏蔽基本概念及理论；</p>
                    <p><span></span>孔缝屏蔽设计；</p>
                    <p><span></span>接缝的屏蔽设计及案例分享；</p>
                    <p><span></span>线缆屏蔽设计及案例分享；</p>
                    <p><span></span>PCB屏蔽设计</p>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="arrange_list_title">
                《防护设计》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    浪涌防护设计
                  </p>
                  <div class="child_course">
                    <p><span></span>防护基本术语；</p>
                    <p><span></span>常用防护器件；</p>
                    <p><span></span>防护器件相关案例分享(2个)；</p>
                    <p><span></span>浪涌过电压的来源及危害；</p>
                    <p><span></span>浪涌侵入路径、测试要求及防护设计总体思路；</p>
                    <p><span></span>防护电路的协调设计及失效安全；</p>
                    <p><span></span>常用端口防护设计—电源口防护电路设<br>计、网口防护电路设计、POE&RS485防护<br>电路设计、汽车电源口防护电路设计</p>
                    <p><span></span>浪涌防护相关案例分析（6个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD防护设计
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD基础知识和测试要求；</p>
                    <p><span></span>ESD设计：防止ESD进入设备、加固敏感<br>电路、软件容错设计；</p>
                    <p><span></span>ESD相关案例分析（2个）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD防护设计
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD基础知识和测试要求；</p>
                    <p><span></span>ESD设计：防止ESD进入设备、加固敏感<br>电路、软件容错设计；</p>
                    <p><span></span>ESD相关案例分析（2个）</p>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="arrange_list_title">
                《全流程EMC设计实战》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    某物联网终端产品EMC正向设计
                  </p>
                  <div class="child_course">
                    <p><span></span>NE-C200物联网终端产品概述；</p>
                    <p><span></span>EMC需求分析及规格确定；</p>
                    <p><span></span>EMC总体设计方案</p>
                    <p><span></span>电路EMC设计评审</p>
                    <p><span></span>PCB EMC设计评审</p>
                    <p><span></span>EMC测试验证</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    某检漏仪产品EMC正向设计
                  </p>
                  <div class="child_course">
                    <p><span></span>检漏仪产品概述</p>
                    <p><span></span>EMC需求分析及设计规格</p>
                    <p><span></span>EMC系统设计、详细设计及设计评审</p>
                    <p><span></span>EMC测试验证</p>
                  </div>
                </div>
              </div>
            </li>

            <li style="margin-top: 2rem;">
              <p class="arrangeTag">《通用产品EMC定位整改》</p>
            </li>

            <li>
              <div class="arrange_list_title">
                《传导发射(CE)定位整改》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    传导发射问题及测试要求
                  </p>
                  <div class="child_course">
                    <p><span></span>传导发射问题；</p>
                    <p><span></span>电源口传导发射测试布置和测试要求；</p>
                    <p><span></span>信号口传导发射测试布置和测试要求</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    开关电源传导噪声干扰源分析
                  </p>
                  <div class="child_course">
                    <p><span></span>开关信号引起的谐波干扰；</p>
                    <p><span></span>寄生参数或漏感引起的振铃或振荡</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    开关电源传导噪声耦合路径分析
                  </p>
                  <div class="child_course">
                    <p><span></span>开关电源CE噪声传导耦合路径；</p>
                    <p><span></span>开关电源CE噪声近场耦合路径</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    开关电源传导发射问题定位的仪器设备
                  </p>
                  <div class="child_course">
                    <p><span></span>频域的定位诊断设备</p>
                    <p><span></span>时域的定位诊断设备</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    开关电源传导发射问题常用抑制措施
                  </p>
                  <div class="child_course">
                    <p><span></span>EMI滤波器的措施</p>
                    <p><span></span>电路上的抑制措施（变压器、吸收电路等）</p>
                    <p><span></span>PCB上的抑制措施</p>
                    <p><span></span>屏蔽上的抑制措施</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    传导发射相关典型案例分析
                  </p>
                  <div class="child_course">
                    <p>4个案例</p>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="arrange_list_title">
                《辐射发射(RE)定位整改》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射发射问题及其测试要求
                  </p>
                  <div class="child_course">
                    <p><span></span>辐射发射问题；</p>
                    <p><span></span>辐射发射测试要求；</p>
                    <p><span></span>辐射发射测试方法</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    电磁辐射机理分析
                  </p>
                  <div class="child_course">
                    <p><span></span>辐射发射的关键要素</p>
                    <p><span></span>辐射源分析</p>
                    <p><span></span>差模辐射</p>
                    <p><span></span>共模辐射</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射问题定位的仪器设备及必备器件
                  </p>
                  <div class="child_course">
                    <p>便携频谱仪、近场探头套件、电压探针、电流探头、光纤探头、可视化EMI诊断测试系统、常用的器件和材料</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射问题定位小技巧
                  </p>
                  <div class="child_course">
                    <p>分辨靠得很近的窄带噪声源，在多个时钟源中定位主要的时钟源，测试电缆的谐振频率，测试机箱谐振，根据辐射测试结果分析噪声源等8个小技巧</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射发射问题常用的整改措施
                  </p>
                  <div class="child_course">
                    <p><span></span>结构上的整改措施</p>
                    <p><span></span>地线、电源电缆辐射的整改措施</p>
                    <p><span></span>屏蔽和非屏蔽信号电缆辐射的整改措施</p>
                    <p><span></span>板内关键电路上的整改措施</p>
                    <p><span></span>PCB布局，层叠和布线上的整改措施</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射发射问题定位的一般程序
                  </p>
                  <div class="child_course">
                    <p><span></span>确认背景噪声</p>
                    <p><span></span>外接电缆辐射和机箱辐射定位</p>
                    <p><span></span>机箱辐射的整改措施</p>
                    <p><span></span>外接电缆辐射的整改措施</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    辐射相关典型案例分析
                  </p>
                  <div class="child_course">
                    <p>3个案例</p>
                  </div>
                </div>
              </div>
            </li>
            
            <li>
              <div class="arrange_list_title">
                《浪涌(Surge)定位整改》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    浪涌产生机理及失效模式
                  </p>
                  <div class="child_course">
                    <p><span></span>浪涌产生机理</p>
                    <p><span></span>浪涌失效模式</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    浪涌测试方法
                  </p>
                  <div class="child_course">
                    <p><span></span>仪器设备原理</p>
                    <p><span></span>浪涌电压波形</p>
                    <p><span></span>浪涌实验加扰方式</p>
                    <p><span></span>浪涌实验等级</p>
                    <p><span></span>试验结果评价</p>
                    <p><span></span>ITU多级防护协调验证测试方法</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    浪涌诊断设备及诊断技巧
                  </p>
                  <div class="child_course">
                    <p><span></span>浪涌测试设备</p>
                    <p><span></span>防雷元件测试仪</p>
                    <p><span></span>示波器</p>
                    <p><span></span>高压探头</p>
                    <p><span></span>隔离变压器、电流探头</p>
                    <p><span></span>芯片耐受能力测试（EOS设备）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    浪涌定位整改
                  </p>
                  <div class="child_course">
                    <p><span></span>浪涌对策整改流程图</p>
                    <p><span></span>防护器件损坏、后级电路损坏、芯片损<br>坏、器件绝缘耐压</p>
                    <p><span></span>浪涌路径</p>
                    <p><span></span>多级防护协调</p>
                    <p><span></span>PCB布局布线上的整改措施</p>
                    <p><span></span>浪涌发生设备输出异常</p>
                    <p><span></span>接地</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    典型案例分析
                  </p>
                  <div class="child_course">
                    <p>6个案例</p>
                  </div>
                </div>
              </div>
            </li>
            
            <li>
              <div class="arrange_list_title">
                《静电(ESD)定位整改》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD产生机理、耦合方式与失效模式分析 
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD产生机理</p>
                    <p><span></span>ESD噪声耦合方式：传导耦合、场耦合</p>
                    <p><span></span>ESD失效模型：硬失效、软失效、暂时混乱</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD抗扰度标准及测试方法
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD测试标准介绍</p>
                    <p><span></span>ESD测试方法：直接放电（接触放电、空<br>气放电）、间接放电</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD诊断设备及诊断技巧
                  </p>
                  <div class="child_course">
                    <p><span></span>E1脉冲发生器</p>
                    <p><span></span>ESD可视化定位诊断系统</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD整改措施
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD整改思路</p>
                    <p><span></span>常用整改措施：杜绝ESD的发生；阻隔<br>ESD传导方式流入板内；屏蔽处理；软件<br>处理</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD问题整改典型案例分析
                  </p>
                  <div class="child_course">
                    <p>8个案例</p>
                  </div>
                </div>
              </div>
            </li>
            
            <li>
              <div class="arrange_list_title">
                《产品EMC整改实战》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    某4K产品辐射发射定位整改
                  </p>
                  <div class="child_course">
                    <p><span></span>辐射问题背景：产品介绍、辐射测试布<br>置、原始辐射测试结果</p>
                    <p><span></span>定位分析：背景噪声定位；结构屏蔽、<br>搭接和接地定位；线缆和接口辐射定位</p>
                    <p><span></span>辐射整改措施：外购电源适配器的EMI改<br>进；12V电源口电路和PCB的EMI改进；外<br>壳屏蔽和搭接改进；电路板接地改进；信<br>号接口电路及PCB EMI改进</p>
                    <p><span></span>整改后测试结果</p>
                    <p><span></span>关键点定位整改实操演示（录像）</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    某门禁产品ESD定位整改
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD定位整改过程的实操演示（录像）</p>
                  </div>
                </div>
              </div>
            </li>
            
            <li style="margin-top: 2rem;">
              <p class="arrangeTag">《CST软件EMC仿真》</p>
            </li>
            
            <li>
              <div class="arrange_list_title">
                《CST软件EMC仿真入门》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST软件概述
                  </p>
                  <div class="child_course">
                    <p><span></span>CST软件简介</p>
                    <p><span></span>CST软件发展历程</p>
                    <p><span></span>CST软件算法</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST工作室套装
                  </p>
                  <div class="child_course">
                    <p><span></span>用户界面</p>
                    <p><span></span>各工作室简介</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST工作界面
                  </p>
                  <div class="child_course">
                    <p><span></span>CST微波工作室工作界面</p>
                    <p><span></span>CST设计工作室工作界面</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST入门实例
                  </p>
                  <div class="child_course">
                    <p><span></span>用微波工作室分析T型波导的S参数及场分布</p>
                    <p><span></span>用设计工作室分析EMI滤波器的插入损耗</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    设计建模详解
                  </p>
                  <div class="child_course">
                    <p><span></span>基本操作：工作平面和坐标轴；导航树和<br>历史树；更改模型的名称、分组和材质；<br>更改模型的颜色、透明度和显示形式；模<br>型选择；改变模型视图；基本模型及其建<br>模操作</p>
                    <p><span></span>高级操作：拉伸表面、旋转表面和渐变；<br>几何变换；布尔操作；倒斜角和倒圆角；<br>掏空；切割模型和分离模型；坐标系；模<br>型的导入、导出</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST微波工作室的背景材料和边界条件详解
                  </p>
                  <div class="child_course">
                    <p><span></span>背景材料设置</p>
                    <p><span></span>边界条件设置及类型</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST微波工作室端口和激励详解
                  </p>
                  <div class="child_course">
                    <p><span></span>端口激励</p>
                    <p><span></span>场激励</p>
                    <p><span></span>集总元件</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST微波工作室求解器详解
                  </p>
                  <div class="child_course">
                    <p><span></span>求解器总体介绍</p>
                    <p><span></span>时域求解器设置</p>
                    <p><span></span>频域求解器设置</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CST微波工作室数据后处理
                  </p>
                  <div class="child_course">
                    <p><span></span>数据后处理概述</p>
                    <p><span></span>场监视器设置</p>
                    <p><span></span>查看仿真分析结果</p>
                    <p><span></span>分析结果显示方式</p>
                    <p><span></span>数据后处理模板</p>
                    <p><span></span>分析结果的导入和导出</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    CST设计工作室设置详解
                  </p>
                  <div class="child_course">
                    <p><span></span>电路建模及端口设置</p>
                    <p><span></span>Simulation Task设置</p>
                  </div>
                </div>
              </div>
            </li>
            
            <li style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
              <div class="arrange_list_title">
                《CST软件CE仿真算例》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    CE仿真算例介绍
                  </p>
                  <div class="child_course">
                    <p><span></span>背景简介</p>
                    <p><span></span>仿真要求</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    Buck电源电路上的性能仿真
                  </p>
                  <div class="child_course">
                    <p><span></span>Buck电源的电路图</p>
                    <p><span></span>器件参数说明</p>
                    <p><span></span>电路建模过程的操作演示</p>
                    <p><span></span>瞬态仿真任务设置</p>
                    <p><span></span>激励信号设置</p>
                    <p><span></span>探针设置</p>
                    <p><span></span>启动仿真分析及查看仿真结果</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    Buck电源纯电路上的CE仿真
                  </p>
                  <div class="child_course">
                    <p><span></span>Buck电源电路模型中加入LISN</p>
                    <p><span></span>查看CE仿真结果</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    Buck电源考虑PCB Layout影响的CE仿真
                  </p>
                  <div class="child_course">
                    <p><span></span>3D建模及相关设置</p>
                    <p>1.通过标准模板创建一个CE仿真分析工程</p>
                    <p>2.导入PCB文件</p>
                    <p>3.进行电源连接器PIN建模并进行2个PIN 的S参数端口设置</p>
                    <p>4.所需要器件的S参数端口设置</p>
                    <p>5.3D中集总元件的参数设置</p>
                    <p>6.背景材料及边界条件补充设置</p>
                    <p>7.进行网格、求解器的设置并启动3D仿真分析</p>
                    <p><span></span>电路建模及相关设置</p>
                    <p>1.电路建模、连线及探针设置</p>
                    <p>2.瞬态仿真任务设置</p>
                    <p>3.激励信号设置并启动仿真分析</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    Buck电源CE仿真结果分析
                  </p>
                  <div class="child_course">
                    <p><span></span>有滤波电路情况下，纯电路CE仿真结果和<br>考虑PCB Layout影响时CE仿真结果的比对</p>
                    <p><span></span>考虑PCB Layout影响的条件下，有滤波电<br>路和无滤波电路时CE仿真结果的比对</p>
                    <p><span></span>考虑PCB Layout影响的条件下，有滤波电<br>路和无滤波电路时PCB内部电场的分布情<br>况比对</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="arrange_list_title">
                《CST软件RE仿真算例》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    RE仿真算例介绍
                  </p>
                  <div class="child_course">
                    <p><span></span>算例概述</p>
                    <p><span></span>时钟信号拓扑结构</p>
                    <p><span></span>广义传递函数的仿真思路</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    裸板时钟线RE仿真建模及相关设置
                  </p>
                  <div class="child_course">
                    <p><span></span>3D建模及相关设置：</p>
                    <p>通过标准模板创建一个RE仿真分析工程</p>
                    <p>导入PCB文件</p>
                    <p>集总元件参数设置</p>
                    <p>球面探针设置</p>
                    <p>网格设置</p>
                    <p>求解器设置并启动仿真分析</p>
                    <p><span></span>电路建模及相关设置：</p>
                    <p>1.电路建模、连线及探针设置</p>
                    <p>2.瞬态仿真任务设置</p>
                    <p>3.激励信号设置并启动仿真分析</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    裸板时钟线RE仿真结果分析
                  </p>
                  <div class="child_course">
                    <p><span></span>裸板的50MHz时钟线在3m球面的辐射</p>
                    <p><span></span>在J1连接器的时钟信号管脚附近增加一根<br>GND管脚，再次仿真分析对RE辐射的改善程度</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    半电波暗室RE测试环境模拟
                  </p>
                  <div class="child_course">
                    <p><span></span>半电波暗室RE测试环境介绍</p>
                    <p><span></span>通过实际操作演示和讲解：</p>
                    <p>--利用边界条件的设置来模拟暗室的6个面</p>
                    <p>--利用背景材料的设置来模拟暗室地面与受试PCB之间的距离</p>
                    <p>--进行圆柱面的探头设置，并且水平探头朝向圆柱面的切向方向，垂直探头朝向圆柱面的轴线方向</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="arrange_list_title">
                《CST软件ESD仿真算例》
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD仿真算例介绍
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD仿真算例介绍</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD发生器模拟及性能验证
                  </p>
                  <div class="child_course">
                    <p><span></span>ESD发生模型介绍</p>
                    <p>
                      <span></span>创建参考接地平面；设置端口；边界条件<br>
                      和背景材料设置；电路建模、连线及探针<br>
                      设置；瞬态求解器、激励信号设置；仿真<br>
                      验证结果分析</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD仿真建模及相关设置
                  </p>
                  <div class="child_course">
                    <p><span></span>3D建模及相关设置：</p>
                    <p>1、通过标准模板创建一个ESD仿真分析工程</p>
                    <p>2、导入手机模型</p>
                    <p>3、创建泡沫垫和接地参考平面的模型</p>
                    <p>4、导入ESD发生器模型</p>
                    <p>5、端口设置</p>
                    <p>6、边界条件和背景材料设置</p>
                    <p>7、网格设置</p>
                    <p><span></span>电路建模及相关设置：</p>
                    <p>1、电路建模</p>
                    <p>2、探针设置</p>
                    <p>3、瞬态仿真任务创建和设置</p>
                    <p>4、激励信号设置并启动仿真分析</p>
                  </div>
                </div>
              </div>
              <div class="arrange_list_con" style="border-radius: 0 0 1.5rem 1.5rem; overflow: hidden;">
                <div class="arrange_list_child">
                  <p class="course">
                    ESD仿真结果分析
                  </p>
                  <div class="child_course">
                    <p><span></span>查看手机天线端口感应的ESD噪声</p>
                    <p><span></span>在手机天线端口增加瞬态抑制二极管TVS，<br>仿真分析TVS管对ESD噪声的抑制作用</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 用户验证， 口碑保障-->
      <div class="uesr">
        <img class="title" :src="`${pagebase}/static/img/emc/title_7.png`">
        <img class="user_img" :src="`${pagebase}/static/img/emc/user.png`" alt="">
      </div>

      <!-- 好评反馈 -->
      <div class="good">
        <img class="title" :src="`${pagebase}/static/img/emc/title_8.png`">
        
        <div class="tv">
          <video width="100%" controls playsinline="true" :poster="`${pagebase}/static/img/emc/cover.jpg`">
            <source src="http://1500011843.vod2.myqcloud.com/6caa3839vodcq1500011843/dfb6ac96387702301683765492/ToD7Seaiu6AA.mp4" type="video/mp4">
          </video>
        </div>
        
        <div class="advicecon">
          <div class="advice">
            <img :src="`${pagebase}/static/img/emc/studentsNo1.jpg`" alt="">
            <img :src="`${pagebase}/static/img/emc/studentsNo3.jpg`" alt="">
            <img :src="`${pagebase}/static/img/emc/studentsNo4.jpg`" alt="">
            <img :src="`${pagebase}/static/img/emc/studentsNo5.jpg`" alt="">
            <img :src="`${pagebase}/static/img/emc/studentsNo6.jpg`" alt="">
          </div>
        </div>
      </div>

      <!-- 进班需知 -->
      <div class="inform">
        <img class="title" :src="`${pagebase}/static/img/emc/title_9.png`">
        <div class="inform_con">
          <div class="inform_list">
            <div class="issue">
              <img :src="`${pagebase}/static/img/emc/issue.png`" alt="">
              <p>学习形式是什么样的？</p>
            </div>
            <div class="answer">
              <img :src="`${pagebase}/static/img/emc/answer.png`" alt="">
              <p>线上通过巣粉引擎进行知识学习和实战项目的演示，通过电巢直播间每周带学1次，带学包括重点难点讲解以及答疑解惑。</p>
            </div>
          </div>
          <div class="inform_list">
            <div class="issue">
              <img :src="`${pagebase}/static/img/emc/issue.png`" alt="">
              <p>多长时间可以学会掌握这些知识和技能？学不会怎么办？</p>
            </div>
            <div class="answer">
              <img :src="`${pagebase}/static/img/emc/answer.png`" alt="">
              <p>我们根据学员基础差异化会设置学习计划，4个月一个培训周期，只要用心学，每个人都能成为企业不可或缺的优秀EMC工程师。</p>
            </div>
          </div>
          <div class="inform_list">
            <div class="issue">
              <img :src="`${pagebase}/static/img/emc/issue.png`" alt="">
              <p>如感觉自己没有学好，可以一直跟营学习吗？</p>
            </div>
            <div class="answer">
              <img :src="`${pagebase}/static/img/emc/answer.png`" alt="">
              <p>随时随地线上观看学习，如果课程周期内感觉没学好，可以在开课起1年半内免费无限次回看课程视频，反复巩固。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 开班流程 -->
      <div class="flow">
        <img class="title" :src="`${pagebase}/static/img/emc/title_10.png`">
        <div class="flowCon">
          <div class="flowTop">
            <div class="">
              <img :src="`${pagebase}/static/img/emc/flow_1.png`" alt="" class="icon_3">
              <p>报名</p>
              <p>支付成功</p>
            </div>
            <p>
              <img :src="`${pagebase}/static/img/emc/next.png`" alt="" class="next">
            </p>
            <div class="">
              <img :src="`${pagebase}/static/img/emc/flow_2.png`" alt="" class="icon_3">
              <p>添加</p>
              <p>助教老师</p>
            </div>
            <p>
              <img :src="`${pagebase}/static/img/emc/next.png`" alt="" class="next">
            </p>
            <div class="">
              <img :src="`${pagebase}/static/img/emc/flow_3.png`" alt="" class="icon_3">
              <p>获取训练营服</p>
              <p>务及入营链接</p>
            </div>
            <p>
              <img :src="`${pagebase}/static/img/emc/next.png`" alt="" class="next">
            </p>
            <div class="">
              <img :src="`${pagebase}/static/img/emc/flow_4.png`" alt="" class="icon_3">
              <p>开营学习</p>
              <p>开启实战</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 关于电巢 -->
      <div class="about">
        <img class="title" :src="`${pagebase}/static/img/emc/title_11.png`">
        <div class="about_con">
          <p>电巢是电子工程师的孵化巢，拥有200万+知识库，200+专家资源，共享实验室平台，
            2000+合作企业，旗下电子工程师社区（www.EDA365.com）是40余万电子工程师信赖的技术交流和能力提升的平台,
            电巢 服务于有创新有追求的工程师和积极寻求成长并坚信人才是核心竞争力的企业。
          </p>
        </div>
      </div>

      <!-- 报名 -->
      <div class="consult_btn">
        <div @click="arrangeShow">
          <img :src="`${pagebase}/static/img/emc/consult.png`" alt="">
          <p>团报咨询</p>
        </div>
      </div>
      <div class="down_btn">
        <div class="price">
          <p class="originalCost">原价 <s>￥{{activityCon.cash_origin_price}}</s></p>
          <p class="currentPrice">优惠价 ￥<span>{{activityCon.cash_price}}</span></p>
        </div>
        <div class="signUp_btn" @click="signUp">
          立即报名
        </div>
      </div>
      <div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
        <div class="consult_alert_con">
          <div class="consult_alert_ma">
            <p>保存识别二维码</p>
            <p>发送“EMC”咨询入营</p>
            <img :src="`${pagebase}/static/img/emc/erweima.png`" alt="">
          </div>
          <div class="consult_close_btn">
            <img class="" :src="`${pagebase}/static/img/emc/close.png`" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  // 百度
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},

        show: false,
        xHeader: false,
        showAll: true,
        showAwait: false,
        showAccomplish: false,
        showCancel: false,
        arrangeshow: false,
        pagebase: pagebase,
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.wxshare = new WxShare();
        this.getactivityCon();
        this.showStat();
      },
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },
      allCourse() {
        this.show = true;
      },
      closeAlert() {
        this.show = false;
      },
      arrangeShow() {
        this.arrangeshow = true;
      },
      consultClose() {
        this.arrangeshow = false;
      },
      myclick(v, type) {
        if (type === 'all') {
          this.showAll = true;
          this.showAwait = false;
          this.showAccomplish = false;
          this.showCancel = false;
        } else if (type === 'await') {
          this.showAll = false;
          this.showAwait = true;
          this.showAccomplish = false;
          this.showCancel = false;
        } else if (type === 'accomplish') {
          this.showAll = false;
          this.showAwait = false;
          this.showAccomplish = true;
          this.showCancel = false;
        } else if (type === 'cancel') {
          this.showAll = false;
          this.showAwait = false;
          this.showAccomplish = false;
          this.showCancel = true;
        }
        var divs = document.getElementsByClassName("tab_css");
        for (var y = 0; y < divs.length; y++) {
          var divv = divs[y];
          if (divv == document.getElementById("tab" + v + "_content")) {
            divv.style.display = "block";
          } else {
            divv.style.display = "none";
          }
        }
        var teacher = document.getElementsByClassName("teacherName");
        for (var i = 0; i < teacher.length; i++) {
          var teav = divs[i];
          if (teav == document.getElementById("name_" + v)) {
            teav.style.color = "red";
          } else {
            teav.style.color = "#080943";
          }
        }
      },
      
      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=emc' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'emc',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .emcPublicity {
    position: relative;
    background-color: #080943;
  }

  .banner {
    width: 100%;
    background-color: #080943;
  }

  .banner img {
    width: 100%;
  }

  .content {
    margin-top: 1.5rem;
    padding: 0 1.4rem 8.5rem 1.4rem;
  }

  .title {
    height: 3.6rem;
    margin-top: 1rem;
  }

  .work {
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .work_list {
    margin-top: 1.5rem;
  }

  .work_list li {
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .work_con {
    box-sizing: border-box;
    padding: 1.5rem 0;
    border-bottom: .1rem solid #3353D8;
  }

  .work_cons {
    box-sizing: border-box;
    padding: 1.5rem 0;
  }

  .work_list_child_title {
    font-size: 1.4rem;
    color: #0A2480;
    font-weight: 600;
  }

  .work_list_child_title span {
    font-size: 1.2rem;
    color: #ED7726;
    font-weight: 600;
  }

  .work_list_child_con {
    font-size: 1.2rem;
    color: #485E80;
    margin-top: .6rem;
  }

  .work_icon {
    height: 4.8rem;
    margin-right: .6rem;
  }

  .crowd {
    background-color: #3353D8;
    margin-top: 2rem;
    border-radius: .5rem;
    box-sizing: border-box;
    padding: 1.2rem .7rem;
  }

  .crowd_title {
    color: #FFF;
    font-size: 1.2rem;
  }

  .crowd_con {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }

  .crowd_con div {
    background: linear-gradient(#78CFE8, #BBDC9E);
    font-size: 1.1rem;
    padding: .4rem .4rem;
    border-radius: .5rem;
  }

  .crowd_con p {
    width: 1rem;
    height: .3rem;
    background-color: #FC9B58;
  }

  .feature {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    background-color: #F0F7FF;
  }

  .global {
    position: relative;
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  
  .advice img{
    width: 100%;
    margin-top: 2rem;
  }

  .promote_mod {
    background-size: 100% 100%;
    border-radius: .5rem;
    overflow: hidden;
    margin-top: 1rem;
  }

  .promote_title {
    background: linear-gradient(to left, #BFDBFF, #A3BCFB);
    color: #080808;
    font-size: 1.6rem;
    font-weight: 600;
    height: 4rem;
    box-sizing: border-box;
    border-radius: .5rem .5rem 0 0;
    display: flex;
    align-items: center;
    padding-left: 1rem;
  }

  .promote_title img {
    height: 2.6rem;
    margin-right: .5rem;
  }

  .promote_con {
    background-color: #D9E2FD;
    line-height: 2rem;
    background-size: 100% 100%;
    padding: 1.8rem 1.2rem 1.2rem 1.2rem;
    box-sizing: border-box;
    font-size: 1.2rem;
    color: #0A2480;
  }

  .promote_con li {
    margin-top: 1rem;
  }

  /deep/.swiper-pagination-bullet {
    margin: 0 .5rem;
    background: #FC9B58;
  }

  .reap {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .reap_list {
    margin-top: 3rem;
    border-radius: .5rem;
    overflow: hidden;
  }

  .reap_list li {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .reap_icon_1 {
    box-sizing: border-box;
    width: 15%;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.3rem .7rem .8rem .7rem;
  }

  .reap_icon_1 img {
    height: 3.5rem;
  }

  .reap_con_1 {
    box-sizing: border-box;
    width: 85%;
    padding: 1.2rem .8rem;
    background-color: #CCDEFF;
    height: 6rem;
    display: flex;
    flex-direction: column;
  }

  .reap_icon_2 {
    box-sizing: border-box;
    width: 15%;
    height: 7.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.8rem .7rem;
  }

  .reap_icon_2 img {
    height: 3.5rem;
  }

  .reap_con_2 {
    box-sizing: border-box;
    width: 85%;
    padding: 1.2rem .8rem;
    background-color: #CCDEFF;
    height: 7.6rem;
    display: flex;
    flex-direction: column;
  }

  .reap_list_child_title {
    font-size: 1.4rem;
    color: #DD3700;
    font-weight: 600;
  }

  .reap_list_child_con {
    font-size: 1.2rem;
    color: #080943;
    margin-top: .4rem;
  }

  .grasp {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .grasp_con {
    box-sizing: border-box;
  }

  .grasp_img1 {
    margin-top: 2.2rem;
    width: 100%;
  }

  .grasp_img2 {
    margin-top: 2.2rem;
    width: 100%;
  }

  .arrange {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .course_structure {
    margin-top: 3rem;
    width: 100%;
  }

  .catalogue {
    margin-top: 3rem;
    margin-bottom: 1rem;
    height: 1.6rem;
  }

  .arrangeTag {
    box-sizing: border-box;
    width: 21rem;
    height: 3rem;
    line-height: 3rem;
    background-color: #0A2480;
    font-size: 1.4rem;
    color: #FFFFFF;
    margin-left: -1.3rem;
    padding-left: 1.9rem;
    border-radius: 0 3rem 3rem 0;
  }

  .arrange_list {
    position: relative;
    height: 70rem;
    overflow: hidden;
  }

  .arrange_list_title {
    height: 4rem;
    background-color: #3353D8;
    color: #FFFFFF;
    font-size: 1.4rem;
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.5rem 1.5rem 0 0;
    margin-top: 2rem;
  }

  .arrange_list_con {
    box-sizing: border-box;
    background-color: #FFFFFF;
    margin-bottom: .5rem;
  }

  .arrange_list_child {
    display: flex;
  }

  .course {
    box-sizing: border-box;
    width: 7.4rem;
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    font-size: 1.2rem;
    color: #0A2480;
    background-color: #C0D9FF;
    padding: 1rem .6rem;
  }

  .child_course {
    box-sizing: border-box;
    width: 24.75rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #DFEAFF;
    font-size: 1.1rem;
    color: #0A2480;
    padding: 1rem 0rem 1rem 1rem;
  }

  .child_course p {
    display: flex;
  }

  .child_course p span {
    display: inline-block;
    width: .4rem;
    height: .4rem;
    border-radius: 50%;
    background-color: #0A2480;
    margin-right: .4rem;
    margin-top: .7rem;
  }

  .course_name {
    margin-left: 1.4rem;
  }

  .course_name_4 {
    margin-left: 1rem;
  }



  .show_all {
    box-sizing: border-box;
    width: 100%;
    padding: 1.4rem 0;
    background: linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 1));
    color: #DD3700;
    font-size: 1.4rem;
    font-weight: 600;
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .show_all img {
    height: 1.8rem;
    margin-left: .6rem;
    margin-top: .3rem;
  }

  .arrange_alert {
    display: none;
    box-sizing: border-box;
    z-index: 5;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    overflow: auto;
  }

  .arrange_alert_list {
    background-color: #FFFFFF;
  }

  .arrange_alert_txt {
    background-color: #FFFFFF;
    box-sizing: border-box;
    position: absolute;
    width: 32rem;
    height: 580px;
    top: 50%;
    left: 50%;
    margin-top: 100px;
    margin-left: -16rem;
    margin-top: -290px;
    overflow: auto;
  }

  .arrange_alert_txt li {
    background-color: #FFFFFF;
    border-radius: 1.6rem;
  }

  .close_btn {
    margin-right: 10px;
  }

  .show {
    height: 100%;
    display: block;
  }

  .teacher {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .tab_bar {
    width: 100%;
  }

  .tabBtn {
    top: 8.8rem;
  }

  .tab_bar ul {
    display: flex;
    padding: 0px;
    margin: 0px;
    text-align: center;
  }

  .tab_bar li {
    width: 25%;
    font-size: 1.2rem;
  }

  .tab_bar li:hover {
    color: red;
  }

  .teacher_icon {
    margin-top: 1.5rem;
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 50%;
    opacity: 0.5;
  }

  .opacity {
    opacity: 1;
  }

  .teacherName {
    color: rgba(8, 9, 67, 0.6);
  }

  .color {
    color: rgba(8, 9, 67, 1);
  }

  .decorationLine {
    color: red;
    position: relative;
    font-weight: 600;
  }

  .decorationLine>.tab_line {
    background-color: #F5A623;
  }

  .tab_line {
    width: 100%;
    height: .6rem;
    background-color: #EDDEC6;
  }

  .fillMod {
    height: 4.4rem;
    background-color: #F7F8F8;
  }

  .tab_css {
    display: none;
    position: relative;
  }

  .teacher_con {
    background-color: #FFF;
    box-sizing: border-box;
    margin-top: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    height: 17rem;
  }

  .teacher_head {
    width: 10.4rem;
    object-fit: cover;
    height: 15.5rem;
  }

  .teacher_txt {
    width: 21rem;
    box-sizing: border-box;
    padding: 0 1rem 2.5rem 2rem;
    line-height: 1.7rem;
  }

  .teacher_honor {
    box-sizing: border-box;
    width: 100%;
    height: 6rem;
    background-color: #DFEAFF;
    padding-top: .5rem;
    padding-left: 1.5rem;
  }

  .teacher_honor_name {
    color: #080943;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .teacher_honor_child {
    color: #0A2480;
    font-size: 1rem;
  }

  .down_1 {
    width: 2rem;
    position: absolute;
    left: 3rem;
  }

  .down_2 {
    width: 2rem;
    position: absolute;
    left: 11rem;
  }

  .down_3 {
    width: 2rem;
    position: absolute;
    left: 19rem;
  }

  .down_4 {
    width: 2rem;
    position: absolute;
    left: 27rem;
  }

  .teacher_synopsis {
    color: #0A2480;
    font-size: 1.1rem;
  }

  .uesr {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .user_img {
    margin-top: 3.2rem;
    width: 100%;
  }

  .good {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    background-color: #F0F7FF;
    overflow: hidden;
    padding-bottom: 2rem;
  }

  .good_title {
    font-size: 1.4rem;
    color: #080943;
    padding-top: 1rem;
    display: flex;
    align-items: center;
    background-color: #DFEAFF;
  }

  .good_title img {
    margin-left: 1rem;
    margin-right: 1rem;
    width: 4.5rem;
    height: 4.5rem;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .tv {
    margin-top: 1rem;
  }
  
  .tv_title {
    font-size: 1.6rem;
    font-weight: 600;
  }
  
  .videoCon{
    margin-bottom: 1.5rem;
  }
  
  .videoCon p{
    height: 2rem;
    line-height: 2rem;
    font-size: 1.2rem;
    background-color: #DFEAFF;
    padding: 0 1rem;
    border-radius: 2rem;
    display: inline-block;
    margin-bottom: .5rem;
  }

  .good_txt {
    background-color: #DFEAFF;
    height: 12rem;
    background-size: 100% 100%;
    padding: 1.8rem 1rem 1rem 1rem;
    box-sizing: border-box;
    font-size: 1.2rem;
    color: #0A2480;
  }

  .inform {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .inform_con {
    margin-top: 2.7rem;
    background-color: #DFEAFF;
    border-radius: .5rem;
    box-sizing: border-box;
    padding: 0 .9rem .4rem .9rem;
  }

  .inform_con img {
    height: 2.5rem;
    margin-right: 1.4rem;
  }

  .inform_list {
    border-bottom: .1rem solid #3353D8;
    padding-bottom: 1.2rem;
    padding-top: 1.2rem;
  }

  .inform_list:nth-last-child(1) {
    border-bottom: none;
  }

  .issue {
    display: flex;
    align-items: center;
    color: #080943;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .answer {
    margin-top: .6rem;
    display: flex;
    align-items: center;
    color: #0A2480;
    font-size: 1.2rem;
  }

  .flow {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
  }

  .flowCon {
    box-sizing: border-box;
  }

  .flowTop {
    display: flex;
    justify-content: space-between;
  }

  .flowTop div {
    font-size: 1.2rem;
    color: #0A2480;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .icon_3 {
    width: 6.5rem;
  }

  .next {
    width: 1.2rem;
    margin-top: 3rem;
  }

  .about {
    margin-top: 2rem;
    box-sizing: border-box;
    border-radius: 1rem;
    padding: 0 1.3rem;
    padding-bottom: 1.6rem;
    background-color: #F0F7FF;
    font-size: 1.4rem;
    color: #0A2480;
  }

  .about_con {
    margin-top: 1.5rem;
    line-height: 2.2rem;
  }

  .down_btn {
    box-sizing: border-box;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 3;
    position: fixed;
    align-items: center;
    left: 0;
    bottom: 0;
    justify-content: center;
    display: flex;
    justify-content: space-between;
    padding: 1.5rem 2.5rem;
    color: #FFF;
  }

  .price {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .originalCost {
    color: #DDD;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .currentPrice {
    font-size: 1.4rem;
    font-weight: 600;
    /* margin-top: .4rem; */
  }

  .currentPrice span {
    font-size: 2rem;
    font-weight: 600;
    color: #FFE864;
  }

  .signUp_btn {
    box-sizing: border-box;
    text-align: center;
    width: 12rem;
    height: 3.4rem;
    line-height: 3.4rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #000000;
    background: linear-gradient(#78CFE8, #BBDC9E);
    /* background: #90E9C1; */
    border-radius: 2.2rem;
  }

  .consult_btn {
    z-index: 4;
    position: fixed;
    right: 1rem;
    bottom: 8.5rem;
    text-align: center;
    font-size: 1.8rem;
    font-weight: 600;
    color: #000000;
    margin-right: .5rem;
    border-radius: 2.2rem;
  }

  .consult_btn img {
    width: 7.5rem;
  }

  .consult_btn p {
    width: 100%;
    margin-top: -1.8rem;
    padding: .4rem 0;
    color: #FFE864;
    font-size: 1rem;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 5;
    border-radius: .5rem;
  }

  .consult_alert {
    display: none;
    z-index: 5;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .consult_alert_con {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -14rem;
    margin-left: -14rem;
    width: 28rem;
    height: 28rem;
    background-color: #F3F7FC;
    border-radius: 1rem;
  }

  .consult_alert_ma {
    height: 100%;
    display: flex;
    font-size: 1.8rem;
    font-weight: 600;
    color: #080943;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .consult_alert_ma img {
    width: 15rem;
    height: 15rem;
  }

  .arrangeshow {
    display: block;
  }

  .consult_close_btn {
    margin-top: .5rem;
    display: flex;
    justify-content: center;
  }

  .consult_close_btn img {
    width: 3.8rem;
    height: 3.8rem;
  }
  
  .students{
    width: 25rem;
    height: 30rem;
    display: flex;
  }
  
  .students img{
    width: 100%;
    object-fit: contain;
  }

  @media (min-width: 751px) {
    .arrange_alert {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }

    .arrange_alert_txt {
      box-sizing: border-box;
      position: absolute;
      width: 32rem;
      height: 880px;
      top: 50%;
      left: 50%;
      margin-left: -16rem;
      margin-top: -440px;
      overflow: auto;
    }
    
    .consult_btn {
      right: 50%;
      margin-right: -355px;
    }

    .down_btn {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }

  @media (max-width: 1600px) {
    .arrange_alert_txt {
      box-sizing: border-box;
      position: absolute;
      width: 32rem;
      height: 580px;
      top: 50%;
      left: 50%;
      margin-left: -16rem;
      margin-top: -290px;
      overflow: auto;
    }
  }
</style>
